const IP = async function() {
    const url = 'https://api.ipstack.com/check?access_key=4ae7a4a013c8a3f5e9e2d3eeb046d8ca';
    const response = await fetch(url);
    const data = await response.json();
    this.json = data;
    currencyCode = this.json.currency.code;
}